import { MBIconV2Name } from '@shared/components/image';
import { API } from '@shared/types/api';
import { GenericComponent } from '../../config';
import { isDateComponent } from '../../utils';
import { FieldOption } from './FieldOption';

export class BatchDateFieldOption implements FieldOption {
  public missingDependencies: FieldOption[] = [];

  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<GenericComponent>,
    readonly componentDependencies: FieldOption[],
  ) {}

  matchesComponent(component: API.AnyComponent): boolean {
    return this.component.id === component.id && this.component.type === component.type;
  }

  canBeAdded(components: API.AnyComponent[]): boolean {
    const hasExistingBatchDateComponent = components
      .filter(isDateComponent)
      .some(c => c.allowEntityBatchCreation);

    return !hasExistingBatchDateComponent;
  }

  updateMissingDependencies(components: API.AnyComponent[]) {
    this.missingDependencies = this.componentDependencies.filter(dep => dep.canBeAdded(components));
  }
}
